namespace $ { $mol_style_attach( "mol/plot/map/heat/heat.view.css",
 "[mol_plot_map_heat_level_curve] {\n\tstroke-linecap: square;\n\tfill: none;\n}\n"
) }